import * as React from 'react';
import { connect } from 'react-redux';
import { types } from '../../constants/types';
import { ChunkDetailsMO } from '../../models/ChunkDetailsMO';
import './ChunkDetails.css';
import { Analysis } from '../Analysis/Analysis';
import { ChunkListMO } from '../../models/ChunkListMO';
import { WordManager } from '../../Manager/WordManager';
import { GraphCheckListMO } from '../../models/GraphCheckListMO';
// import { HashWord } from "../../Utils/HashWord";
import { ExclusionsMO } from '../../models/ExclusionsMO';
import { ParagraphMO } from '../../models/ParagraphMO';
import { WordMO } from '../../models/WordMO';
import ExcludeParagraph from './ExcludeParagraph';
import { ConfigManager } from '../../Manager/ConfigManager';
import AppCallout from '../AppCallout/AppCallout';

export interface AppProps {
	//
	chunkDetailsMO: ChunkDetailsMO;
	setChunkDetailsMO;
	setWordTypeScoreMO;
	chunkListMO: ChunkListMO;
	graphCheckListMO: GraphCheckListMO;

	exclusionsMO: ExclusionsMO;
}

export interface AppState {
	//
	isCalloutVisible: boolean;
}

class ChunkDetails extends React.Component<AppProps, AppState> {
	private _spanElements = {};
	private _currentSpan: { key: string; type: string };

	constructor(props, context) {
		super(props, context);

		this.state = { isCalloutVisible: false };
	}

	componentDidMount() {}

	componentWillUnmount() {}

	moveToWord = (_paragraphIdx: number, _wordIdx: number, _word: string) => {
		console.log(_word, _paragraphIdx, _wordIdx);
	};

	private getWordType(className: string) {
		let result: string = '';
		switch (className) {
			case 'verb':
				result = 'Verbs';
				break;
			case 'noun':
				result = 'Nouns';
				break;
			case 'preposition':
				result = 'Prepositions';
				break;
			case 'ad_':
				result = 'AdjectivesAdverbs';
				break;
			case 'waste':
				result = 'WasteWords';
				break;
			default:
				break;
		}

		return result;
	}

	private addWord(
		listWord: JSX.Element[],
		word: string,
		paragraphIdx: number,
		wordIdx: number,
		searchWord: string = null,
		key: string,
		className: string = 'normal',
	) {
		listWord.push(
			<span
				ref={(element) => {
					this._spanElements[key] = element;
				}}
				key={key}
				className={className}
				onClick={() => {
					if (searchWord !== null) {
						this._currentSpan = { key: key, type: this.getWordType(className) };

						this.setState({ isCalloutVisible: !this.state.isCalloutVisible });
						this.moveToWord(paragraphIdx, wordIdx, searchWord);
					}
				}}>
				{word}
			</span>,
		);
	}

	private combineGraphCheckList() {
		const { graphCheckListMO } = this.props;
		if (
			graphCheckListMO.cVerb === false &&
			graphCheckListMO.cNoun === false &&
			graphCheckListMO.cPrep === false &&
			graphCheckListMO.cWaste === false &&
			graphCheckListMO.cAd_ === false
		) {
			return true;
		}
		return false;
	}

	private changeColor(words: WordMO[], paragraphIdx: number) {
		const { graphCheckListMO } = this.props;
		let analysis: Analysis = new Analysis();
		let listItems: JSX.Element[] = [];
		let followsPeriod = true;
		if (words.length > 0) {
			words.forEach((wordMO, idx) => {
				let word = wordMO.word;

				if (wordMO.exclude) {
					this.addWord(
						listItems,
						word,
						paragraphIdx,
						idx,
						null,
						'ex' + idx,
						'exclude',
					);
				} else {
					WordManager.separateWord(word).forEach((term, i) => {
						switch (analysis.identifyWord(term, followsPeriod)) {
							case 0:
								if (
									graphCheckListMO.cVerb === true ||
									this.combineGraphCheckList() === true
								) {
									this.addWord(
										listItems,
										term,
										paragraphIdx,
										idx,
										word,
										`v_${paragraphIdx}_${idx}_${i}`,
										'verb',
									);
								} else {
									this.addWord(
										listItems,
										term,
										paragraphIdx,
										idx,
										null,
										`v_${paragraphIdx}_${idx}_${i}`,
										'normal',
									);
								}
								break;
							case 1:
								if (
									graphCheckListMO.cNoun === true ||
									this.combineGraphCheckList() === true
								) {
									this.addWord(
										listItems,
										term,
										paragraphIdx,
										idx,
										word,
										`n_${paragraphIdx}_${idx}_${i}`,
										'noun',
									);
								} else {
									this.addWord(
										listItems,
										term,
										paragraphIdx,
										idx,
										null,
										`n_${paragraphIdx}_${idx}_${i}`,
										'normal',
									);
								}
								break;
							case 2:
								if (
									graphCheckListMO.cPrep === true ||
									this.combineGraphCheckList() === true
								) {
									this.addWord(
										listItems,
										term,
										paragraphIdx,
										idx,
										word,
										`p_${paragraphIdx}_${idx}_${i}`,
										'preposition',
									);
								} else {
									this.addWord(
										listItems,
										term,
										paragraphIdx,
										idx,
										null,
										`p_${paragraphIdx}_${idx}_${i}`,
										'normal',
									);
								}
								break;
							case 3:
								if (
									graphCheckListMO.cAd_ === true ||
									this.combineGraphCheckList() === true
								) {
									this.addWord(
										listItems,
										term,
										paragraphIdx,
										idx,
										word,
										`ad__${paragraphIdx}_${idx}_${i}`,
										'ad_',
									);
								} else {
									this.addWord(
										listItems,
										term,
										paragraphIdx,
										idx,
										null,
										`ad__${paragraphIdx}_${idx}_${i}`,
										'normal',
									);
								}
								break;
							case 4:
								if (
									graphCheckListMO.cWaste === true ||
									this.combineGraphCheckList() === true
								) {
									this.addWord(
										listItems,
										term,
										paragraphIdx,
										idx,
										word,
										`w_${paragraphIdx}_${paragraphIdx}_${idx}_${i}`,
										'waste',
									);
								} else {
									this.addWord(
										listItems,
										term,
										paragraphIdx,
										idx,
										null,
										`w_${paragraphIdx}_${paragraphIdx}_${idx}_${i}`,
										'normal',
									);
								}
								break;
							default:
								this.addWord(
									listItems,
									term,
									paragraphIdx,
									idx,
									null,
									`d_${paragraphIdx}_${idx}_${i}`,
									'normal',
								);
								break;
						}
					});
				}
				followsPeriod = word.endsWith('.') && !word.endsWith('..');

				this.addWord(
					listItems,
					' ',
					null,
					null,
					null,
					`s_${paragraphIdx}_${idx}_`,
					'normal',
				);
			});
		}

		return listItems;
	}

	isBlock(paragraph: ParagraphMO) {
		const { exclusionsMO } = this.props;
		if (
			(exclusionsMO.headings && paragraph.isHeading) ||
			(exclusionsMO.tables && paragraph.isTable) ||
			(exclusionsMO.indentedParagraphs && paragraph.isLeftIndent) ||
			(exclusionsMO.listItems && paragraph.isList) ||
			paragraph.wc === 0
		) {
			return true;
		}
		return false;
	}

	renderCallout = () => {
		const onCalloutDismiss = () => {
			this.setState({ isCalloutVisible: false });
		};

		return (
			<AppCallout
				key={'_callout' + this._currentSpan.key}
				target={this._spanElements[this._currentSpan.key]}
				onDismiss={() => {
					onCalloutDismiss();
				}}
				onClick={() => {
					onCalloutDismiss();
				}}
				title={ConfigManager.getMetrics()[this._currentSpan.type].key}
				text={
					ConfigManager.getMetrics()[this._currentSpan.type].longDescription
				}>
				<div className="ms-CalloutExample-header">
					<h3 className="ms-CalloutExample-title" id={'_calloutLabel'}>
						{' '}
					</h3>
				</div>
				<div className="ms-CalloutExample-inner">
					<div className="ms-CalloutExample-content">
						<p className="ms-CalloutExample-subText" id={'_calloutDescription'}>
							<br />
						</p>
					</div>
				</div>
			</AppCallout>
		);
	};

	renderContent = (content: ParagraphMO[]) => {
		let listItems: JSX.Element[] = [];
		let paragraphs: ParagraphMO[] = [];

		for (let i = 0; i < content.length; i++) {
			const paragraph = content[i];

			if (this.isBlock(paragraph)) {
				if (paragraph.text.length > 0) {
					paragraphs.push(paragraph);
				}
			} else {
				if (paragraphs.length > 0) {
					listItems.push(
						<ExcludeParagraph
							key={i}
							paragraphs={paragraphs}></ExcludeParagraph>,
					);
					paragraphs = [];
				}

				let result = this.changeColor(paragraph.words, i);
				listItems.push(<div key={`p_${i}`}>{result}</div>);
			}
		}

		if (paragraphs.length > 0) {
			listItems.push(
				<ExcludeParagraph
					key={content.length}
					paragraphs={paragraphs}></ExcludeParagraph>,
			);
			paragraphs = [];
		}
		return listItems;
	};

	render() {
		return (
			<div className="chunk-details-content">
				{this.state.isCalloutVisible ? this.renderCallout() : ''}

				{this.renderContent(this.props.chunkDetailsMO.data.content)}
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch) => ({
	setChunkDetailsMO: (chunkDetailsMO) => {
		dispatch({
			type: types.SET_CHUNK_DETAILS,
			chunkDetailsMO: chunkDetailsMO,
		});
	},
	setWordTypeScoreMO: (wordTypeScoreMO) => {
		dispatch({
			type: types.SET_SCORE,
			wordTypeScoreMO: wordTypeScoreMO,
		});
	},
});

const mapStateToProps = ({
	chunkDetailsMO,
	chunkListMO,
	graphCheckListMO,
	exclusionsMO,
}) => ({
	chunkDetailsMO,
	chunkListMO,
	graphCheckListMO,
	exclusionsMO,
});

export default connect(mapStateToProps, mapDispatchToProps)(ChunkDetails);
